import styled from 'styled-components';

export const LoadingWrapper = styled.div`
  background-color: #490026;
  position: fixed;
  padding: 0;
  margin: 0;

  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  z-index: 99999999;
`;

export const LoadingWrapperImilk = styled.div`
  background-color: #320533;
  display: flex;
  position: fixed;
  padding: 0;
  margin: 0;

  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  z-index: 99999999;
`;

export const LoadingImage = styled.img`
  @-webkit-keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @-moz-keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @-o-keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  position: fixed;
  padding: 0;
  margin: 0;

  width: 30%;
  top: 30%;
  left: 36%;
  @media (max-width: 801px) {
    width: 75% !important;
    top: 40% !important;
    left: 15% !important;
  }

  //-webkit-animation: blink 1.5s infinite ease-in-out;
  //-moz-animation: blink 1.5s infinite ease-in-out;
  //-o-animation: blink 1.5s infinite ease-in-out;
  //animation: blink 1.5s infinite ease-in-out;
`;

export const LoadingImageImilk = styled.img`
  @-webkit-keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @-moz-keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @-o-keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  
  //margin: auto;
  display: block;
  width: 440px;
  margin-bottom: 70px;

  //-webkit-animation: blink 1.5s infinite ease-in-out;
  //-moz-animation: blink 1.5s infinite ease-in-out;
  //-o-animation: blink 1.5s infinite ease-in-out;
  //animation: blink 1.5s infinite ease-in-out;
`;

export const LoadingLabel = styled.div`
  width: 100%;
  bottom: 0;
  text-align: center;
  margin-bottom: 110px;
  position: absolute;
  font-size: 30px;
  color: white;

  @media (max-width: 1500px) {
    margin-bottom: 60px;
    font-size: 28px;
  }

  @media (max-width: 1300px) {
    margin-bottom: 60px;
    font-size: 24px;
  }

  @media (max-width: 1100px) {
    margin-bottom: 60px;
    font-size: 20px;
  }


  body {
    background-color: #47d1da;
  }
  p {
    color: white;
    font: 300 4em/150% Impact;
    text-align: center;
  }

  @keyframes dots {
    0%,
    20% {
      color: rgba(0, 0, 0, 0);
      text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    40% {
      color: white;
      text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    60% {
      text-shadow: 0.25em 0 0 white, 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    80%,
    100% {
      text-shadow: 0.25em 0 0 white, 0.5em 0 0 white;
    }
  }

  /* loading dots */

  :after {
    content: ' .';
    animation: dots 1s steps(5, end) infinite;
  }
`;

export const LoadingLabelImilk = styled.div`
    margin: 40px;
    font-size: 32px;
    color: white;
    text-align: center;
    line-height: 40px;
 
  @media (max-width: 801px) {
    font-size: 32px;
  }
  body {
    background-color: #47d1da;
  }
  p {
    color: white;
    font: 300 4em/150% Impact;
    text-align: center;
  }

  @keyframes dots {
    0%,
    20% {
      color: rgba(0, 0, 0, 0);
      text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    40% {
      color: white;
      text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    60% {
      text-shadow: 0.25em 0 0 white, 0.5em 0 0 rgba(0, 0, 0, 0);
    }
    80%,
    100% {
      text-shadow: 0.25em 0 0 white, 0.5em 0 0 white;
    }
  }

  /* loading dots */

  :after {
    content: ' .';
    animation: dots 1s steps(5, end) infinite;
  }
`;
